<template>
  <div class="card-holder">
    <router-link :to="'/event/' + event.event_id">
      <div class="card">
        <div class="card-image">
          <img :src="event.image">
        </div>
        <div class="card-content">
          <h5 class="text-green">{{ event.title }}</h5>
          <h6>{{ event.start_date | datetime }}</h6>
          <div class="card-details">
            <p v-html="event.description"></p>
            <div v-if="event.location" class="grid-x" style="margin-bottom:1rem">
              <div class="cell shrink">
                <span v-html="$icons.get('location_arrow', 'small')" style="margin-right:.3rem"></span>
              </div>
              <div class="cell auto">
                {{ event.location.title }}
              </div>
            </div>
            <!--<p>
              <router-link 
                :to="'/event/' + event.event_id"
                class="btn btn-primary btn-small">
                More info
              </router-link>
            </p>-->
          </div>
        </div>
        <!--<div class="add-event">
          <add-event-button></add-event-button>
        </div>-->
      </div>
    </router-link>
  </div>
</template>

<script>
import dayjs from 'dayjs'
//import AddEventButton from '@/AddEventButton.vue'

export default {
  name: 'EventCard',
  /* components: {
    AddEventButton
  }, */
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      show_detail : false
    }
  },
  methods: {
    toggleDetail () {
      this.show_detail = (this.show_detail == false)
    }
  },
  filters: {
    date (val) {
      let dt = dayjs(val)
      return val ? dt.format('MMMM D, YYYY') : ''
    },
    datetime (val) {
      let dt = dayjs(val)
      return val ? dt.format('MMMM D, YYYY h:mm a') : ''
    },
    time (val) {
      let dt = dayjs(val)
      return val ? dt.format('h:mm a') : ''
    }
  }
}
</script>
